import { type ClassValue, clsx } from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export function merge(...args: ClassValue[]) {
  return twMerge(clsx(args));
}

export const guard = (
  value: unknown,
  render?: (value: unknown) => ReactNode,
  predicate?: (value: unknown) => boolean
) => {
  if (!!value && (!predicate || (predicate && predicate(value)))) {
    return <>{render?.(value)}</>;
  }
  return null;
};
